import Concepts from "../../../../src/components/concepts";
import ComponentCoverage from "../../../../src/components/component-coverage";
import * as React from 'react';
export default {
  Concepts,
  ComponentCoverage,
  React
};